import React from "react";
import { Zap } from "lucide-react";

// Small inline lightning bolt SVG used decoratively
export const BoltMark = ({ className = "w-6 h-6 text-storm-bolt" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
    </svg>
);

// Big background lightning illustration (used in section accents)
export const LightningStreaks = ({ className = "" }) => (
    <svg viewBox="0 0 800 600" className={className} aria-hidden="true">
        <defs>
            <linearGradient id="bolt-g" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.0" />
                <stop offset="50%" stopColor="#FFE800" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0.0" />
            </linearGradient>
        </defs>
        <path
            d="M380 0 L320 220 L420 220 L300 460 L420 300 L320 300 L460 60 Z"
            fill="url(#bolt-g)"
            opacity="0.35"
        />
        <path
            d="M120 40 L100 180 L160 180 L80 360"
            stroke="rgba(255,255,255,0.25)"
            strokeWidth="1.5"
            fill="none"
        />
        <path
            d="M640 80 L620 220 L680 220 L600 420"
            stroke="rgba(255,255,255,0.18)"
            strokeWidth="1.5"
            fill="none"
        />
    </svg>
);

export const BoltIcon = Zap;
